
import { SubjectMapped } from "..";
import { ITextFormControlOptions } from "../text-form-control";
import { FormControlOptionsUtils } from "./utils/form-control-options-utils";

export class SSTextOptions implements Required<SubjectMapped<ITextFormControlOptions>> {

  constructor(
    private _initialOptions?: ITextFormControlOptions
  ) {

    this._initOptions();
  }

  private _initOptions() {

    FormControlOptionsUtils.initMappedObject<'text'>(this, this._initialOptions);

  }

  dispose() {

  }
}
